import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { useTranslation } from 'react-i18next';
import  { fetchPermissions } from 'store/reducers/usersGroupCreator';
import ControlReport from './ControlGroups/ControlReport';
import ControlDocument from './ControlGroups/ControlDocument';
import ControlTable from './ControlGroups/ControlTable';

type ControlButtonsTypes = {
  onSegmentCahnge: (value: string | number) => Promise<void>;
  isAvailableUploading: boolean;
};

const ControlButtons = ({
  onSegmentCahnge,
  isAvailableUploading,
}: ControlButtonsTypes) => {  
  const { viewType } = useAppSelector((state) => state.documents);
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const { rolesPermissions } = useAppSelector((state) => state.dataUsers);
  
  const { t, i18n } = useTranslation();

  const dispatch = useAppDispatch();
  const locale = i18n.language || 'en';

  React.useEffect(() => {
    !rolesPermissions[0] && dispatch(fetchPermissions({ t }));
  }, [dataRoom, locale]);

  const displayedContent = {
    Table: <ControlTable
      onSegmentCahnge={onSegmentCahnge}
      isAvailableUploading={isAvailableUploading}
    />,
    Document: <ControlDocument />,
    Report: <ControlReport />,
  };

  return displayedContent[viewType];
};

export default ControlButtons;
